import React from "react";
import { PropTypes } from "prop-types";
import { MrbListPage, MrbPageHeader } from "mrb/components/layout";
import { MrbGrid } from "mrb/components/grid";
import { MrbRectangleContentLoader } from "mrb/components/loader";
import { MrbButton } from "mrb/components/button";
import { DeviceGridCell, DeviceOnboarding } from "application/device-settings/components";
import { defaultTemplate } from "common/hoc";
import { observer } from "mobx-react";
import { isNil } from "lodash";

function DeviceListTemplate({ deviceListViewStore, t }) {
    const { gridStore, isAddDeviceVisible } = deviceListViewStore;

    return (
        <MrbListPage store={deviceListViewStore} t={t}>
            <MrbPageHeader>
                <div className="c-page__header--top">
                    <div>{t(deviceListViewStore.title)}</div>
                    {isAddDeviceVisible && <HeaderActions store={deviceListViewStore} t={t} />}
                </div>
            </MrbPageHeader>
            <h1 className="u-type--base u-mar--bottom--sml">
                {t("APPLICATION.DEVICE_SETTINGS.LIST.TITLE")}{" "}
                <DeviceCounter deviceListViewStore={deviceListViewStore} t={t} />
            </h1>
            <MrbGrid
                store={gridStore}
                t={t}
                emptyStateRender={() => (
                    <DeviceOnboarding onboardingViewStore={deviceListViewStore.onboardingViewStore} t={t} />
                )}
                cellRender={(props) => <DeviceGridCell {...props} />}
                loaderRender={() => <MrbRectangleContentLoader spacing={30} xBase={0} yBase={0} />}
            />
        </MrbListPage>
    );
}

DeviceListTemplate.propTypes = {
    deviceListViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

const DeviceCounter = observer(function DeviceCounter({ deviceListViewStore, t }) {
    const { gridStore, deviceLimit } = deviceListViewStore;

    if (!gridStore.dataInitialized) {
        return null;
    }

    if (isNil(deviceLimit)) {
        return (
            <React.Fragment>
                ({gridStore.recordCount}/{t("APPLICATION.DEVICE_SETTINGS.LIST.UNLIMITED")})
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            ({gridStore.recordCount}/{deviceLimit})
        </React.Fragment>
    );
});

const HeaderActions = observer(function HeaderActions({ store, t }) {
    return (
        <div className="c-header__actions--end">
            <MrbButton
                t={t}
                label="Add New Device"
                onClick={store.goToAddNewDevice}
                disabled={!store.isAddDeviceEnabled}
            />
            {!store.isAddDeviceEnabled && store.inNakiOneActiveOrScheduled && (
                <MrbButton
                    t={t}
                    label="Unlock Additional Devices"
                    classNameExtend="c-btn--ghost u-mar--left--sml"
                    onClick={store.showDeviceLimitReachedPopup}
                />
            )}
        </div>
    );
});

export default defaultTemplate(DeviceListTemplate);
